import { Role } from './../user.model';
import { AuthService } from './../auth.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ItineraryService } from "./../itinerary.service";
import { Itinerary, Status, TransportationReservation, TransportationReservationRoute, CarType, Day } from "./../itineray.model";
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { MediaMatcher } from '@angular/cdk/layout';
import { ItineraryWorkflowService } from '../itinerary-workflow.service';
import { GpxExporterService } from '../gpx-exporter.service';
import { MatDialog } from '@angular/material/dialog';
import { RearrangeDaysDialogComponent } from '../rearrange-days-dialog/rearrange-days-dialog.component';

import * as firebase from "firebase/app";
import "firebase/firestore";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: "app-itinerary",
  templateUrl: "./itinerary.component.html",
  styleUrls: ["./itinerary.component.css"]
})
export class ItineraryComponent implements OnInit, OnDestroy {

  itinerary: Itinerary;

  mobileQuery: MediaQueryList;

  private mobileQueryListener: () => void;

  constructor(
    private route: ActivatedRoute,
    public itineraryService: ItineraryService,
    private authService: AuthService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public itineraryWorkflowService: ItineraryWorkflowService,
    private gpxExporterService: GpxExporterService,
    private matDialog: MatDialog,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
  }

  ngOnInit() {
    this.itinerary = this.route.snapshot.data.itinerary;
    if (this.itinerary.status === Status.TODO) { this.itineraryWorkflowService.init(this.itinerary); }
    this.applySchemaUpgrades();
    this.checkandAlertForIncorrectTimezone();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
  }

  checkandAlertForIncorrectTimezone() {
    let tz: string;
    try {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.warn("Impossibile determinare il timezone corrente.");
    }
    if (tz && tz.toLowerCase() !== "europe/rome") {

      const now = new Date();
      const dateLocalTimezone = now.toLocaleString('it-IT');
      const dateItalyTimezone = now.toLocaleString('it-IT', { timeZone: 'Europe/Rome' });

      if (dateLocalTimezone !== dateItalyTimezone) {
        alert("Attualmente ti trovi nel fuso orario " + tz + ". Al momento non è possibile utilizzare la piattaforma per la realizzazione itinerari dal tuo fuso orario.\nPer favore, imposta (anche solo temporaneamente durante l'utilizzo della piattaforma) il tuo fuso orario su Europa/Roma, grazie.");
      }
    }
  }

  applySchemaUpgrades() {

    // BICICLETTA -> BIKE & AUTO -> CAR
    this.itinerary.reservations.cars.forEach((car) => {
      if (car.type && car.type.toString() === "BICICLETTA") {
        car.type = CarType.BIKE;
      } else if (car.type && car.type.toString() === "AUTO") {
        car.type = CarType.CAR;
      }
    });

    // TransportationReservationRoute.duration
    ["flights", "buses", "cars", "ferries", "trains"].forEach((key: string) => {
      const reservations: TransportationReservation[] = this.itinerary.reservations[key];
      if (reservations && reservations.length > 0) {
        reservations.forEach((reservation: TransportationReservation) => {
          if (reservation.routes && reservation.routes.length > 0) {
            reservation.routes.forEach((route: TransportationReservationRoute) => {
              if (!route.duration) {
                route.duration = { minutes: null, hours: null };
              }
            });
          }
        });
      }

    });

    // DayItineraryActivity.duration
    this.itinerary.days.forEach((day) => {
      day.activities.forEach((activity) => {
        if (!activity.duration) {
          activity.duration = { minutes: null, hours: null };
        }
      });
    });

    // user generated links -> ShortenedLink
    const fixShortenedLink = (value: any) => {
      if (value == null) {
        return {
          longUrl: null,
          shortUrl: null
        };
      } else if (typeof value === "string") {
        return {
          longUrl: value,
          shortUrl: null
        };
      } else { return value; }
    };
    ["flights", "buses", "cars", "ferries", "trains"].forEach((key: string) => {
      const reservations: TransportationReservation[] = this.itinerary.reservations[key];
      if (reservations && reservations.length > 0) {
        reservations.forEach((reservation: TransportationReservation) => {
          reservation.link = fixShortenedLink(reservation.link);
        });
      }
    });
    this.itinerary.reservations.accomodations.forEach((accomodation) => accomodation.proposals.forEach((proposal) => {
      proposal.link = fixShortenedLink(proposal.link);
    }));
    this.itinerary.days.forEach((day) => day.activities.forEach((activity) => {
      activity.link = fixShortenedLink(activity.link);
    }));
    this.itinerary.days.forEach((day) => day.pois.forEach((poi) => {
      poi.link = fixShortenedLink(poi.link);
    }));

    // renderConfig
    if (!this.itinerary.renderConfig) {
      this.itinerary.renderConfig = {
        hideDates: false,
        hideUpsells: true
      };
    }

  }

  isCurrentUserAdmin() {
    return this.authService.user && this.authService.user.hasRole(Role.ADMIN);
  }

  downloadGpx() {

    const gpx = this.gpxExporterService.exportGpx(this.itinerary);

    const blob = new Blob([gpx], {
      type: 'application/gpx+xml'
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.download = this.itinerary.title + ".gpx";
    a.href = url;
    a.click();
  }

  async rearrangeDays() {
    const days: Day[] = await this.matDialog.open(RearrangeDaysDialogComponent, {
      data: { itinerary: this.itinerary, },
      maxWidth: 600
    }).afterClosed().toPromise();

    if (days) {
      for (let i = 0; i < days.length; i++) {
        const day = days[i];
        day.date = firebase.firestore.Timestamp.fromDate(
          new Date(
            this.itinerary.start.toDate().getTime() + 1000 * 60 * 60 * 24 * i
          )
        );

        for (let j = 0; j < day.activities.length; j++) {
          const activity = day.activities[j];
          const dayDate = day.date.toDate();
          const activityDate = activity.time.toDate();
          activityDate.setDate(dayDate.getDate());
          activityDate.setMonth(dayDate.getMonth());
          activityDate.setFullYear(dayDate.getFullYear());
          activity.time = firebase.firestore.Timestamp.fromDate(activityDate);
        }
      }
      this.itinerary.days = days;
      this.router.navigateByUrl("/itineraries/" + this.itinerary.id);

      this.snackBar.open("Giorni riordinati. Controlla che sia tutto a posto e ricordati di salvare.", null, {
        duration: 5000
      });
    }
  }
}
